<template>
  <div id="card" style="overflow: hidden">
    <div class="center-container">
      <div class="mb-4">
          <!-- Loader with big balls -->
        <div v-if="!questions[index]">
          <div class="balls">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <section class="container">
          <div v-if="validQuestions[index]" class="fixed fixed--center" style="z-index: 3; padding: 20px">
            <Vue2InteractDraggable
              v-if="isVisible"
              :interact-out-of-sight-x-coordinate="500"
              :interact-max-rotation="15"
              :interact-x-threshold="200"
              :interact-y-threshold="200"
              :interact-lock-y-axis="true"
              @draggedRight="nextQuestion"
              @draggedLeft="nextQuestion"
              class="rounded-borders card card--one">
              <div class="flex pl-3 pr-3 flex--center text-center shadow-card" style="height: 100%">
                <h4 class="text-primary">
                  {{ validQuestions[index].question }}
                </h4>
              </div>
            </Vue2InteractDraggable>
          </div>
          <div
            v-if="next"
            class="rounded-borders card card--two fixed fixed--center"
            style="z-index: 2">
            <div class="flex text-primary pl-3 pr-3 flex--center text-center shadow-card" style="height: 100%">
              <h4>{{ validQuestions[index + 1].question }}</h4>
            </div>
          </div>
          <div
            v-if="index > 58"
            class="rounded-borders card card--three fixed fixed--center"
            style="z-index: 1">
            <div class="flex pl-3 pr-3 text-primary flex--center shadow-card" style="height: 100%">
              <h4>{{ validQuestions[1].question}}</h4>
            </div>
          </div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import { Vue2InteractDraggable } from 'vue2-interact'

  export default {
    name: 'card',
    components: {
      Vue2InteractDraggable
    },
    data () {
      return {
        isVisible: true,
        index: 0,
        db: firebase.database().ref(),
        questions: [],
        validQuestions: [],
        key: ''
      }
    },
    computed: {
      current () {
        return this.validQuestions[this.index]
      },
      next () {
        return this.validQuestions[this.index + 1]
      }
    },
    created: function () {
      this.db.on('value', (snapshot) => {
        this.questions = snapshot.val()
        this.validQuestions = this.questions.filter((x) => x.status === 'validate')
        this.index = Math.floor(Math.random() * Math.floor(this.validQuestions.length))
      })
    },

    methods: {
      nextQuestion () {
        setTimeout(() => {
          this.isVisible = false
        }, 200)
        setTimeout(() => {
          this.index++
          this.isVisible = true
        }, 300)
      },
      randomQuestion: function () {
        this.index = Math.floor(Math.random() * Math.floor(this.validQuestions.length))
      }
    }
  }
</script>


<style>

  /* Loader */
  .balls {
    width: 4em;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .balls div {
    width: 0.8em;
    height: 0.8em;
    border-radius: 50%;
    background-color: #3AAFB4;
  }

  .balls div:nth-of-type(1) {
    transform: translateX(-100%);
    animation: left-swing 0.5s ease-in alternate infinite;
  }

  .balls div:nth-of-type(3) {
    transform: translateX(-95%);
    animation: right-swing 0.5s ease-out alternate infinite;
  }

  @keyframes left-swing {

    50%,
    100% {
      transform: translateX(95%);
    }
  }

  @keyframes right-swing {
    50% {
      transform: translateX(-95%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  .flex {
    display: flex;
  }
  .flex--center {
    align-items: center;
    justify-items: center;
    justify-content: center;
  }

  .fixed {
    position: fixed;
  }
  .fixed--center {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .rounded-borders {
    border-radius: 12px;
  }
  .card {
    width: 300px;
    height: 400px;
    color: black;
  }
  card--one {
     background-color: pink;
   }
  card--two {
     background-color: red;
     width: 280px;
     top: 51%;
   }
  card--three {
     background-color: orange;
     width: 260px;
     top: 51.8%;
   }
  .shadow-card {
    box-shadow: 0px 4px 34px rgba(58, 175, 180, 0.242488);
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/CardComponent.vue